import {
  CheckinRecord,
  Deposito,
  DriverDelay,
  CancellationReason,
  StatusAnalysis,
  DepositoPerformance,
} from '../types/checkin';

// Mock data de check-ins
export const mockCheckinData: CheckinRecord[] = [
  {
    id: 1,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-19T21:02:37.579988-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Documentação incompleta',
  },
  {
    id: 2,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-19T21:15:19.523074-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 8,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-19T21:54:30.206408-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 9,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-19T22:21:50.060991-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Problema na documentação',
  },
  {
    id: 10,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-20T08:29:00.728075-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Problema na documentação',
  },
  {
    id: 11,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-20T08:35:16.61989-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 12,
    license_plate: 'SWT3F57',
    driver_name: 'VICENTE BATISTA DA SILVA',
    cnh: '03054790853',
    load_order: null,
    checkin_time: '2025-10-20T08:42:58.801251-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00008',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 13,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-20T08:55:14.659415-03:00',
    status: 'Cancelado',
    deposito_id: 19,
    cod_transp: '00047',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 14,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-20T09:33:07.785053-03:00',
    status: 'Finalizado',
    deposito_id: 19,
    cod_transp: '00047',
  },
  {
    id: 15,
    license_plate: 'SPL1H86',
    driver_name: 'ADAILTO PEREIRA SANTOS',
    cnh: '2184450126',
    load_order: null,
    checkin_time: '2025-10-20T10:46:21.359509-03:00',
    status: 'Em Fila',
    deposito_id: 19,
    cod_transp: '00047',
  },
  // Dados adicionais para análise mais robusta
  {
    id: 16,
    license_plate: 'ABC1234',
    driver_name: 'CARLOS MENDES OLIVEIRA',
    cnh: '12345678901',
    load_order: null,
    checkin_time: '2025-10-20T06:15:00.000000-03:00',
    status: 'Cancelado',
    deposito_id: 20,
    cod_transp: '00015',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 17,
    license_plate: 'XYZ5678',
    driver_name: 'JOÃO SILVA SANTOS',
    cnh: '98765432101',
    load_order: null,
    checkin_time: '2025-10-20T07:30:00.000000-03:00',
    status: 'Cancelado',
    deposito_id: 21,
    cod_transp: '00025',
    cancel_reason: 'Problema na documentação',
  },
  {
    id: 18,
    license_plate: 'DEF9012',
    driver_name: 'MARIA SANTOS COSTA',
    cnh: '11223344556',
    load_order: null,
    checkin_time: '2025-10-20T08:00:00.000000-03:00',
    status: 'Em Carregamento',
    deposito_id: 19,
    cod_transp: '00035',
  },
  {
    id: 19,
    license_plate: 'GHI3456',
    driver_name: 'PEDRO FERREIRA GOMES',
    cnh: '55667788990',
    load_order: null,
    checkin_time: '2025-10-20T09:00:00.000000-03:00',
    status: 'Aguardando',
    deposito_id: 20,
    cod_transp: '00045',
  },
  {
    id: 20,
    license_plate: 'JKL7890',
    driver_name: 'LUCAS ALVES RIBEIRO',
    cnh: '44556677889',
    load_order: null,
    checkin_time: '2025-10-20T10:00:00.000000-03:00',
    status: 'Cancelado',
    deposito_id: 21,
    cod_transp: '00055',
    cancel_reason: 'Motorista desistiu',
  },
  {
    id: 21,
    license_plate: 'MNO1234',
    driver_name: 'RAFAEL COSTA SILVA',
    cnh: '77889900112',
    load_order: null,
    checkin_time: '2025-10-20T11:00:00.000000-03:00',
    status: 'Em Fila',
    deposito_id: 19,
    cod_transp: '00065',
  },
  {
    id: 22,
    license_plate: 'PQR5678',
    driver_name: 'ANDERSON SOUZA OLIVEIRA',
    cnh: '33445566778',
    load_order: null,
    checkin_time: '2025-10-20T12:00:00.000000-03:00',
    status: 'Cancelado',
    deposito_id: 20,
    cod_transp: '00075',
    cancel_reason: 'Problema na documentação',
  },
  {
    id: 23,
    license_plate: 'STU9012',
    driver_name: 'BRUNO MARTINS SANTOS',
    cnh: '99887766554',
    load_order: null,
    checkin_time: '2025-10-20T13:00:00.000000-03:00',
    status: 'Finalizado',
    deposito_id: 21,
    cod_transp: '00085',
  },
];

// Mock data de depósitos
export const mockDepositos: Deposito[] = [
  {
    id: 19,
    cod_dep: 19,
    descricao: 'Depósito São Paulo',
    tempo_medio_faturamento: 145,
  },
  {
    id: 20,
    cod_dep: 20,
    descricao: 'Depósito Rio de Janeiro',
    tempo_medio_faturamento: 210,
  },
  {
    id: 21,
    cod_dep: 21,
    descricao: 'Depósito Belo Horizonte',
    tempo_medio_faturamento: 185,
  },
];

// Função para calcular motoristas com atraso
export function calculateDriverDelays(data: CheckinRecord[]): DriverDelay[] {
  const driverMap = new Map < string, CheckinRecord[]> ();

  data.forEach((record) => {
    const key = record.driver_name;
    if (!driverMap.has(key)) {
      driverMap.set(key, []);
    }
    driverMap.get(key)!.push(record);
  });

  const delays: DriverDelay[] = [];

  driverMap.forEach((records, driverName) => {
    const cancelledCount = records.filter(
      (r) => r.status === 'Cancelado'
    ).length;
    const totalRecords = records.length;
    const lastCheckin = records[records.length - 1].checkin_time;
    const licensePlate = records[0].license_plate;

    // Considerar atraso como múltiplos cancelamentos
    const delayScore = cancelledCount * 30; // 30 minutos por cancelamento

    if (cancelledCount > 0) {
      delays.push({
        driver_name: driverName,
        license_plate: licensePlate,
        total_delays: cancelledCount,
        average_delay_minutes: delayScore / totalRecords,
        last_checkin: lastCheckin,
      });
    }
  });

  return delays.sort((a, b) => b.total_delays - a.total_delays).slice(0, 5);
}

// Função para calcular motivos de cancelamento
export function calculateCancellationReasons(
  data: CheckinRecord[]
): CancellationReason[] {
  const reasonMap = new Map < string, number> ();
  const cancelledRecords = data.filter((r) => r.status === 'Cancelado');

  cancelledRecords.forEach((record) => {
    const reason = record.cancel_reason || 'Sem motivo especificado';
    reasonMap.set(reason, (reasonMap.get(reason) || 0) + 1);
  });

  const total = cancelledRecords.length;
  const reasons: CancellationReason[] = [];

  reasonMap.forEach((count, reason) => {
    reasons.push({
      reason,
      count,
      percentage: (count / total) * 100,
    });
  });

  return reasons.sort((a, b) => b.count - a.count);
}

// Função para calcular status travados
export function calculateStuckStatus(data: CheckinRecord[]): StatusAnalysis[] {
  const statusMap = new Map < string, number> ();

  data.forEach((record) => {
    statusMap.set(record.status, (statusMap.get(record.status) || 0) + 1);
  });

  const total = data.length;
  const statuses: StatusAnalysis[] = [];

  statusMap.forEach((count, status) => {
    statuses.push({
      status,
      count,
      percentage: (count / total) * 100,
    });
  });

  return statuses.sort((a, b) => b.count - a.count);
}

// Função para calcular performance dos depósitos
export function calculateDepositoPerformance(
  data: CheckinRecord[],
  depositos: Deposito[]
): DepositoPerformance[] {
  const depositoMap = new Map < number, CheckinRecord[]> ();

  data.forEach((record) => {
    if (!depositoMap.has(record.deposito_id)) {
      depositoMap.set(record.deposito_id, []);
    }
    depositoMap.get(record.deposito_id)!.push(record);
  });

  const performances: DepositoPerformance[] = [];

  depositos.forEach((deposito) => {
    const records = depositoMap.get(deposito.id) || [];
    const cancelledCount = records.filter(
      (r) => r.status === 'Cancelado'
    ).length;
    const taxaCancelamento =
      records.length > 0 ? (cancelledCount / records.length) * 100 : 0;

    performances.push({
      deposito_id: deposito.id,
      descricao: deposito.descricao,
      tempo_medio_faturamento: deposito.tempo_medio_faturamento,
      total_checkins: records.length,
      taxa_cancelamento: taxaCancelamento,
    });
  });

  return performances
    .sort((a, b) => b.tempo_medio_faturamento - a.tempo_medio_faturamento)
    .slice(0, 3);
}
